import React, { useState, useEffect, useRef } from 'react';
import {
    Container,
    TextField,
    Button,
    Typography,
    Autocomplete
} from '@mui/material';
import Barcode from 'react-barcode';
import { useReactToPrint } from 'react-to-print';
import axios from 'axios';

const LABEL_WIDTH = '1.48in';
const LABEL_HEIGHT = '0.98in';

function BarcodeGenerator() {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null); // Changed to null to work with Autocomplete
    const [quantity, setQuantity] = useState(1);
    const [barcodes, setBarcodes] = useState([]);

    const componentRef = useRef();

    // Fetch product data from the API when the component mounts
    useEffect(() => {
        axios.get('https://serverfourpaws.ccsoftwares.com/Item/getItemDetails')
            .then(res => { setProducts(res.data); })
            .catch(error => console.error('Error fetching product data:', error));
    }, []);

    // Generate barcodes based on the selected product and quantity
    const handleGenerate = () => {
        const barcodeList = [];
        for (let i = 0; i < quantity; i++) {
            barcodeList.push(selectedProduct);
        }
        setBarcodes(barcodeList);
    };

    // Handle the print action
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Barcodes',
        pageStyle: `
            @page {
                size: ${LABEL_WIDTH} ${LABEL_HEIGHT};
                margin: 0;
            }

            @media print {
                html,
                body {
                    width: ${LABEL_WIDTH};
                    height: ${LABEL_HEIGHT};
                    margin: 0 !important;
                    padding: 0 !important;
                }

                .barcode-print-sheet {
                    display: block !important;
                    width: ${LABEL_WIDTH} !important;
                    margin: 0 !important;
                    padding: 0 !important;
                }

                .barcode-label {
                    width: ${LABEL_WIDTH} !important;
                    height: ${LABEL_HEIGHT} !important;
                    margin: 0 !important;
                    padding: 0.04in 0.06in !important;
                    box-sizing: border-box !important;
                    overflow: hidden !important;
                    break-inside: avoid;
                    page-break-inside: avoid;
                }

                .barcode-label:not(:last-child) {
                    break-after: page;
                    page-break-after: always;
                }
            }
        `
    });

    return (
        <Container maxWidth="sm" style={{ marginTop: '0em', paddingTop: '10em' }}>
            <Typography variant="h4" gutterBottom>
                Barcode Generator
            </Typography>

            {/* Searchable Dropdown using Autocomplete */}
            <Autocomplete
                value={selectedProduct}
                onChange={(event, newValue) => setSelectedProduct(newValue)} // Sets the selected product
                disablePortal
                id="product-search"
                options={products}
                getOptionLabel={(option) => option.ItemName} // Displays the product name in the dropdown
                isOptionEqualToValue={(option, value) => option.ItemID === value.ItemID} // Ensures the selected option is valid
                renderInput={(params) => <TextField {...params} label="Select Product" fullWidth />}
                style={{ marginBottom: '1em' }}
            />



            <TextField
                type="number"
                label="Number of Barcodes"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                fullWidth
                style={{ marginBottom: '1em' }}
                inputProps={{ min: 1 }}
            />

            <Button
                variant="contained"
                color="primary"
                onClick={handleGenerate}
                style={{ marginRight: '1em' }}
                disabled={!selectedProduct}
            >
                Generate
            </Button>
            <Button
                variant="contained"
                color="secondary"
                onClick={handlePrint}
                disabled={barcodes.length === 0}
            >
                Print
            </Button>

            {/* Display generated barcodes */}
            {barcodes.length > 0 && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div
                        ref={componentRef}
                        className="barcode-print-sheet"
                        style={{
                            marginTop: '0em',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        {barcodes.map((code, index) => (
                            <div
                                key={index}
                                className="barcode-label"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    width: LABEL_WIDTH,
                                    height: LABEL_HEIGHT,
                                    padding: '0.04in 0.06in',
                                    boxSizing: 'border-box',
                                    overflow: 'hidden',
                                }}
                            >
                                <Barcode
                                    value={code.ItemID.toString()}
                                    width={1.2} // Fixed width for the bars
                                    height={42} // Fits within the 0.98-inch label
                                    format="CODE128"
                                    displayValue={true}
                                    fontSize={10}
                                    margin={0}
                                    renderer="svg"
                                    style={{ maxWidth: '100%' }} // Make sure barcode doesn’t overflow
                                />
                                <p
                                    style={{
                                        margin: '1px 0 0',
                                        fontSize: '6px',
                                        lineHeight: 1.1,
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {code.ItemName} <br></br> Rs.{code.sellingPrice} | 4Paws
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </Container>
    );
}

export default BarcodeGenerator;
